import React, {Fragment, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {tiktokOauthActions} from "_actions";
import {Loading} from 'components/common';
import {history} from "_helpers";
import * as Sentry from '@sentry/react';

export default function TikTokUrlRedirect() {
  const dispatch = useDispatch();
  const url = new URL(document.location);
  const values = new URLSearchParams(url.search);
  const tiktokAuthToken = values.get('access_token');

  useEffect(() => {
    if (tiktokAuthToken) {
      const params = { access_token: tiktokAuthToken};
      dispatch(tiktokOauthActions.genAccessToken(params));
    } else {
        Sentry.captureException(new Error("Cannot find access_token in the redirect URL from TikApi (organic). URL: " + url));
    }
  }, []);

  const tiktok = useSelector((state) => state.tiktokOauth);

  if (tiktok.loading) {
    return <Loading />;
  }

  history.push('/company/connectchannels');

  return(
    <Fragment/>
  )
}